<template>
  <div id="notice">
    <div class="container">
      <div class="row">
        <div class="lnb-wrap col-md-3">
          <div class="lnb">
            <h2>고객센터</h2>
            <ul class="lnb-list">
              <li class="item-contact" @click="$router.push({name: 'contact'})">제휴/문의 <span class="right-arrow">></span></li>
              <li class="item-contact active">공지사항 <span class="right-arrow">></span></li>
              <li class="item-contact" @click="$router.push({name: 'faq'})">자주 묻는 질문 <span class="right-arrow">></span></li>
            </ul>
          </div>
        </div>
        <div class="content-wrap col-md-offset-1 col-md-8">
          <div class="row">
            <div class="col-xs-12 padding-0">
              <h3 class="content-title">공지사항</h3>
              <list :id="'notice'"
                    :useDate="true"
                    :loaderActive="loaderActive"
                    :itemList="noticeObj.results"></list>
              <div v-if="noticeObj.count > 0" class="text-center margin-top-40">
                <pagination :count="noticeObj.count"
                            :page="noticeObj.page"
                            :pageSize="10"
                            :btnShow="5"
                            @changePage="getNotice"></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  'use strict'

  import List from '@/components/List'
  import Pagination from '@/components/Pagination'
  import api from '@/api/index'

  export default {
    name: 'notice',
    components: {
      List,
      Pagination
    },
    data: function () {
      return {
        loaderActive: false,
        noticeObj: {
          count: 0,
          page: 1,
          results: []
        }
      }
    },
    methods: {
      getNotice: function (page = 1) {
        const query = `?page=${page}&pageSize=10&popup=N`
        this.loaderActive = true

        // 공지사항을 불러온다.
        api.getNotice(query, response => {
          if (response.error) {
            this.loaderActive = false
          } else {
            if (response.hasOwnProperty('results')) {
              response.page = parseInt(response.page)
              this.noticeObj = response
              this.loaderActive = false

              // 라우터에 전달된 쿼리스트링 또는 파라미터가 있을 경우, 해당 공지사항 내용을 연다.
              this.$nextTick(() => {
                let id = ''
                const route = this.$route
                const query = route.query
                const params = route.params
                const hasQuery = !$.isEmptyObject(query)
                const hasParams = !$.isEmptyObject(params)

                if (hasQuery) {
                  const found = this.noticeObj.results.find((item) => {
                    return item.title.includes(query.title)
                  })
                  id = found.id
                } else if (hasParams) {
                  id = params.id
                }

                if (id) {
                  const el = $(`#notice${id}`)
                  el.collapse('show')

                  this.$nextTick(() => {
                    const position = el.offset().top - 128
                    $('html,body').stop().animate({scrollTop: (position)}, 500)
                  })
                }
              })
            }
          }
        })
      }
    },
    created: function () {
      this.getNotice()
    }
  }
</script>

<style lang="scss" scoped>
  #notice {
    word-break: keep-all;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    p {
      margin: 0;
    }

    .container {
      padding: 154px 16px;

      @media (max-width: 991px) {
        padding: 24px 16px;
      }
    }

    // Local Navigation CSS
    .lnb-wrap {
      padding: 0;

      h2 {
        margin: 0;
        font-size: 26px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.23;
        letter-spacing: -1.4px;
        color: #2e3134;
      }

      .lnb-list {
        margin: 40px 0 0;
        cursor: pointer;

        li {
          padding: 16px 8px;
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: -0.7px;
          color: #868e96;

          &.active,
          &:hover {
            font-size: 16px;
            font-weight: bold;
            color: #2e3134;
            background-color: #f3f4f8;
          }
        }
      }

      .right-arrow {
        float: right;
        font-weight: bold;
      }
    }

    // CS Center CSS
    .content-wrap {
      margin-top: 56px;
      padding: 0;

      .content-title {
        padding: 24px 0;
        margin: 0;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: -1.1px;
        color: #2e3134;
        border-bottom: 2px solid #2e3134;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cscenter/Notice.vue